import axiosClient from "./axiosClient";
import { apiEndpoints } from "./apiEndpoints";

export const login = (values) =>
  axiosClient.post(apiEndpoints.authentication.url, values);
